import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "@/lib/orderUtils";

const SECONDS = 10;

export const KioskReturn = ({ order }) => {
    const navigate = useNavigate();
    const cashDue = order?.pay_method === "cash" && order?.pay_status !== "paid";
    const [left, setLeft] = useState(SECONDS);
    useEffect(() => {
        if (left <= 0) { navigate("/kiosk", { replace: true }); return; }
        const t = setTimeout(() => setLeft(left - 1), 1000);
        return () => clearTimeout(t);
    }, [left, navigate]);

    return (
        <>
        {cashDue && (
            <div className="mt-8 border-2 border-[var(--gold)] p-6 text-center" data-testid="kiosk-cash-due">
                <p className="eyebrow">// Pay at the counter</p>
                <p className="font-display text-[40px] leading-none text-gold mt-2">{formatMoney(order.total)}</p>
                <p className="text-muted text-sm mt-2">Your order #{order.order_number} is being made. Please pay cash at the counter.</p>
            </div>
        )}
        <div className="mt-8 flex flex-wrap items-center gap-4" data-testid="kiosk-return">
            <button className="btn-primary" onClick={() => navigate("/kiosk", { replace: true })} data-testid="kiosk-new-order-btn">
                New order
            </button>
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted" data-testid="kiosk-return-countdown">
                Back to start in {left}s
            </span>
        </div>
        </>
    );
};
